import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { GENDER } from 'domains/seller/constants/seller-constants'

/**
 * To give nice look in gender type by given seller type of the seller
 * @param {string} gender gender type. available value
 * - `female`
 * - `male`
 */
const SellerBadge = ({ gender }) => {

  const colorMap = {
    [GENDER.FEMALE] : 'primary',
    [GENDER.MALE]   : 'warning'
  }

  const color = colorMap[gender] || 'default'

  return <StatusBadge color={ color } label={ gender } />
}

SellerBadge.propTypes = {
  gender: PropTypes.string
}

export default SellerBadge